import { render, staticRenderFns } from "./Remove.vue?vue&type=template&id=5c6a270e"
import script from "./Remove.vue?vue&type=script&lang=js"
export * from "./Remove.vue?vue&type=script&lang=js"
import style0 from "./Remove.vue?vue&type=style&index=0&id=5c6a270e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports